// Default drum instruments used when no custom drumset is provided
export const DEFAULT_INSTRUMENTS = [
  { id: 'BD', name: 'Kick', type: 'kick', sampleId: 'kick-classic', color: 'bg-green-600' },
  { id: 'SD', name: 'Snare', type: 'snare', sampleId: 'snare-analog', color: 'bg-red-600' },
  { id: 'CH', name: 'Closed Hat', type: 'hihat', sampleId: 'hihat-acoustic01', color: 'bg-yellow-600' },
  { id: 'OH', name: 'Open Hat', type: 'openhat', sampleId: 'openhat-acoustic01', color: 'bg-yellow-300' },
  { id: 'T1', name: 'High Tom', type: 'tom', sampleId: 'tom-acoustic01', color: 'bg-blue-400' },
  { id: 'T2', name: 'Low Tom', type: 'tom', sampleId: 'tom-acoustic02', color: 'bg-blue-500' },
  { id: 'CR', name: 'Crash', type: 'crash', sampleId: 'crash-acoustic', color: 'bg-orange-600' },
  { id: 'RD', name: 'Ride', type: 'ride', sampleId: 'ride-acoustic01', color: 'bg-orange-400' }
];
